define([
	"dojo/_base/declare",
	"dojo/dom-class",
	"csi/html",
	"csi/widget/CustomIconWithLabel",
	"Calendar/CompletionRenderer"
], function(declare, domClass, html, CustomIconWithLabel, CompletionRenderer) {

	html.registerDataAttribute("DATA_CALENDAR_ACTIVITY_URL", "calendar-activity");

	return declare(CompletionRenderer, {
		bBaseRenderer: true,

		reserveContext: function(/*Context*/ctx, /*Heading*/h) {
			// summary: render completion date in calendar matrix
			// node can be milestone or rollup
			var node = ctx.getNode();
			var cal = ctx.cache.getNode(node.__Parent__);

			this._reserveContext(ctx, cal, this._getMasterActivity(ctx), false);
			this.inherited(arguments);
		},

		toHtmlStatic: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode, /*ActionData*/actionData) {
			// summary: render value for attribute in HTML
			var bValue = false;

			// After inline action we may get context that was not reserved
			this.reserveContextIfNeeded(ctx, h);

			if (ctx.__activity) {
				html.setDataAttribute(refNode, html.DATA_CALENDAR_ACTIVITY_URL, ctx.__activity.$URL);
				domClass.add(refNode, "bold");
			}

			// display completion date or completeness
			var value = this.toValue(ctx, h);
			var bComplete = true;

			if (!value) {
				value = this._getCalendarValue(ctx, ctx.__rollup, "Completeness");
				bComplete = false;
			}

			if (value) {
				const stateIndex = this._getStateIndex(ctx);

				if (stateIndex === 2) {
					// "CompleteLate" state
					new CustomIconWithLabel({
						icon: "completelate",
						label: value
					}).placeAt(refNode);
				} else {
					html.text(refNode, value);
				}

				bValue = true;
			}

			// display expected end date if not complete and different than target
			if (!bComplete && ctx.__activity) {
				var dateExpected = ctx.__activity.ExpectedEndDate;
				if (dateExpected) {
					var dateTarget = this._getMasterActivity(ctx).TargetDate;
					if (dateExpected != dateTarget) {
						html.create("div", {
							innerText: this.formatValue(dateExpected)
						}, refNode);
						bValue = true;
					}
				}
			}

			// display remarks in cell from the current level (not from the Activity Level)
			if (ctx.view.bShowRemarks) {
				var remarks = this._getCalendarValue(ctx, ctx.cache.getNode(ctx.__remarks.$URL), "Remarks");
				if (remarks) {
					html.create("div", {
						innerText: remarks,
						style: "white-space: normal;"
					}, refNode);

					bValue = true;
				}
			}

			this.releaseContextIfNeeded(ctx, h);

			return bValue;
		},

		toValue: function(/*Context*/ctx, /*Heading*/h) {
			// summary: return value for completion date - use activity if one to get latest value
			return this.formatValue(this._getCalendarValue(ctx, ctx.__rollup, h.m_id));
		},

		_getCalendarValue: function(/*Context*/ctx, /*Node*/rollup, /*String*/id) {
			// summary: get value for attribute - make sure to get indexed value if key
			if (ctx.__activity && (id != "Remarks") && (ctx.__activity.$Type != "Milestone")) {
				return ctx.__activity[id];
			}

			return this.inherited(arguments);
		},

		_getMasterActivity: function(/*Context*/ctx, /*Node?*/cal) {
			// summary: return master activity in current context; it is possible PARAM_COLUMN_URL is not set
			// in context when invoked after editing
			return ctx.getColumnNode() || this.inherited(arguments);
		}
	});
});